// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsletter-banner {
  background-color: var(--color-primary);
  width: 100%;
  box-sizing: border-box;
}

.newsletter-banner-content {
  max-width: 100%;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 0;
  position: relative;
  overflow: hidden;
}

.newsletter-scrolling-container {
  flex: 1 1;
  overflow: hidden;
}

.newsletter-line {
  position: relative;
  margin-bottom: 0.5rem;
  height: 2.2rem;
}

.newsletter-line:last-child {
  margin-bottom: 0;
}

.newsletter-line div {
  white-space: nowrap;
}

/* Styles moved to .newsletter-line-1-text */

/* Newsletter line scrolling - now uses global .scrolling-text animation */
.newsletter-line-out1,
.newsletter-line-out2 {
  /* Global scrolling animation will handle the movement */
}

.newsletter-line-1-text {
  font-family: var(--font-family-scrolling);
  font-size: 2.5rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 1.2;
}

.newsletter-line-1-text .solid {
  color: var(--color-text-primary);
  -webkit-text-fill-color: var(--color-text-primary);
}

.newsletter-line-1-text .outline {
  color: transparent;
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke: 0.8px var(--color-text-primary);
}

.newsletter-line-2-text {
  font-family: var(--font-family-scrolling);
  font-size: 1.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 1.4;
}

.newsletter-line-2-text .solid {
  color: var(--color-white);
  -webkit-text-fill-color: var(--color-white);
}

.newsletter-line-2-text .outline {
  color: transparent;
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke: 0.8px var(--color-white);
}

/* Styles moved to .newsletter-line-2-text */

.newsletter-button {
  background-color: var(--color-white);
  color: var(--color-primary);
  border: none;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  position: absolute;
  right: 10rem;
  transform: translateY(-130%);
  z-index: 100;
}

.newsletter-button-icon {
  width: 45px;
  height: 45px;
  object-fit: contain;
  position: absolute;
  left: 10rem;
  transform: translateY(-140%);
  z-index: 100;
}

.newsletter-banner-content-right {
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
}


.newsletter-button:hover {
  background-color: var(--color-white);
  opacity: 0.9;
  transform: translateY(-140%);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.newsletter-button:active {
  transform: translateY(-140%);
}

/* Responsive Design */
@media (max-width: 768px) {
  .newsletter-line {
    height: 1.8rem;
  }

  .newsletter-line-1-text {
    font-size: 2rem;
  }

  .newsletter-line-2-text {
    font-size: 1.5rem;
  }

  .newsletter-button {
    right: 1rem;
    padding: 0.75rem 1.5rem;
    font-size: 0.9rem;
  }

  .newsletter-button-icon {
    width: 35px;
    height: 35px;
    left: 1rem;
  }
}

@media (max-width: 480px) {
  .newsletter-line {
    height: 1.5rem;
  }

  .newsletter-line-1-text {
    font-size: 1.8rem;
    letter-spacing: 1px;
  }

  .newsletter-line-2-text {
    font-size: 1.3rem;
  }
  
  .newsletter-button {
    right: 0.5rem;
    padding: 0.6rem 1.2rem;
    font-size: 0.8rem;
  }

  .newsletter-button-icon {
    width: 30px;
    height: 30px;
    left: 0.5rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/NewsletterBanner/NewsletterBanner.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;;AAE5C,0EAA0E;AAC1E;;EAEE,wDAAwD;AAC1D;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA,4CAA4C;;AAE5C;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;;AAGA;EACE,oCAAoC;EACpC,YAAY;EACZ,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":[".newsletter-banner {\n  background-color: var(--color-primary);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.newsletter-banner-content {\n  max-width: 100%;\n  margin: 0 auto;\n  align-items: center;\n  justify-content: center;\n  gap: 2rem;\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.newsletter-scrolling-container {\n  flex: 1;\n  overflow: hidden;\n}\n\n.newsletter-line {\n  position: relative;\n  margin-bottom: 0.5rem;\n  height: 2.2rem;\n}\n\n.newsletter-line:last-child {\n  margin-bottom: 0;\n}\n\n.newsletter-line div {\n  white-space: nowrap;\n}\n\n/* Styles moved to .newsletter-line-1-text */\n\n/* Newsletter line scrolling - now uses global .scrolling-text animation */\n.newsletter-line-out1,\n.newsletter-line-out2 {\n  /* Global scrolling animation will handle the movement */\n}\n\n.newsletter-line-1-text {\n  font-family: var(--font-family-scrolling);\n  font-size: 2.5rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  line-height: 1.2;\n}\n\n.newsletter-line-1-text .solid {\n  color: var(--color-text-primary);\n  -webkit-text-fill-color: var(--color-text-primary);\n}\n\n.newsletter-line-1-text .outline {\n  color: transparent;\n  -webkit-text-fill-color: transparent;\n  -webkit-text-stroke: 0.8px var(--color-text-primary);\n}\n\n.newsletter-line-2-text {\n  font-family: var(--font-family-scrolling);\n  font-size: 1.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  line-height: 1.4;\n}\n\n.newsletter-line-2-text .solid {\n  color: var(--color-white);\n  -webkit-text-fill-color: var(--color-white);\n}\n\n.newsletter-line-2-text .outline {\n  color: transparent;\n  -webkit-text-fill-color: transparent;\n  -webkit-text-stroke: 0.8px var(--color-white);\n}\n\n/* Styles moved to .newsletter-line-2-text */\n\n.newsletter-button {\n  background-color: var(--color-white);\n  color: var(--color-primary);\n  border: none;\n  padding: 1rem 2rem;\n  font-size: 1rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  border-radius: 15px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  position: absolute;\n  right: 10rem;\n  transform: translateY(-130%);\n  z-index: 100;\n}\n\n.newsletter-button-icon {\n  width: 45px;\n  height: 45px;\n  object-fit: contain;\n  position: absolute;\n  left: 10rem;\n  transform: translateY(-140%);\n  z-index: 100;\n}\n\n.newsletter-banner-content-right {\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  position: relative;\n}\n\n\n.newsletter-button:hover {\n  background-color: var(--color-white);\n  opacity: 0.9;\n  transform: translateY(-140%);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.newsletter-button:active {\n  transform: translateY(-140%);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .newsletter-line {\n    height: 1.8rem;\n  }\n\n  .newsletter-line-1-text {\n    font-size: 2rem;\n  }\n\n  .newsletter-line-2-text {\n    font-size: 1.5rem;\n  }\n\n  .newsletter-button {\n    right: 1rem;\n    padding: 0.75rem 1.5rem;\n    font-size: 0.9rem;\n  }\n\n  .newsletter-button-icon {\n    width: 35px;\n    height: 35px;\n    left: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .newsletter-line {\n    height: 1.5rem;\n  }\n\n  .newsletter-line-1-text {\n    font-size: 1.8rem;\n    letter-spacing: 1px;\n  }\n\n  .newsletter-line-2-text {\n    font-size: 1.3rem;\n  }\n  \n  .newsletter-button {\n    right: 0.5rem;\n    padding: 0.6rem 1.2rem;\n    font-size: 0.8rem;\n  }\n\n  .newsletter-button-icon {\n    width: 30px;\n    height: 30px;\n    left: 0.5rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
